// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");
let Colors = require("uikit/styles/colors");

function TextLabelV5(props) {
  let __className = props.className;
  let explanationMark = props.explanationMark;
  let className = __className !== undefined ? __className : "";
  let defaultColor = Stdlib_Option.getOr(props.color, Colors.tuatara);
  let defaultBorderColor = Stdlib_Option.getOr(props.borderColor, Colors.alto);
  let defaultBg = Stdlib_Option.getOr(props.bg, Colors.white);
  return JsxRuntime.jsxs("div", {
    children: [
      props.children,
      explanationMark !== undefined ? JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("span", {
              children: "!"
            }),
            JsxRuntime.jsx("div", {
              children: explanationMark,
              className: TailwindMerge.twMerge([
                "hidden absolute px-3 py-2 bg-zinc-700/95 text-white leading-tight normal-case min-w-[150px] left-1/2 -translate-x-1/2 bottom-[calc(100%+13px)] z-10 rounded-md",
                "before:content-[''] before:absolute before:left-1/2 before:top-full before:-translate-x-1/2 before:w-0 before:h-0 before:border-solid before:border-t-[10px] before:border-x-[8px] before:border-x-transparent before:border-t-zinc-700/95",
                "group-hover:block"
              ])
            })
          ],
          className: TailwindMerge.twMerge(["absolute w-[18px] h-[18px] rounded-full bg-tan-error-500 top-[-9px] right-[-10px] font-medium text-white flex justify-center items-center text-base leading-[1] group"])
        }) : null
    ],
    className: TailwindMerge.twMerge([
      "inline-flex items-center h-[26px] font-bold leading-[1] border border-solid py-[1px] px-2.5 cursor-default whitespace-nowrap shrink-0 text-sm rounded-[4px] uppercase",
      explanationMark !== undefined ? "relative" : "",
      className
    ]),
    style: {
      backgroundColor: defaultBg,
      borderColor: defaultBorderColor,
      color: defaultColor
    }
  });
}

let make = TextLabelV5;

exports.make = make;
/* tailwind-merge Not a pure module */
